module.exports = __webpack_public_path__ + "img/facing1.jpg?409749c69f52d44cd55cce2f4b4a6882";